import React from "react";
import { CalendarDays, ChevronRight, Clock3, MapPin } from "lucide-react";
import pickupPinImage from "../../assets/cargaazul_optimized_92.webp";
import deliveryPinImage from "../../assets/descargavermelha_optimized_92.webp";

// Shared between the Trucks and Drivers right panels.
export function OperationalSessionTabs({
  sessions = [],
  selectedId,
  onSelect,
  getPoints,
  getLabel,
  getFlag,
  getName,
}) {
  if (sessions.length < 2) return null;

  return (
    <div className="live-transports-map__truck-session-links">
      {sessions.map((session) => {
        const points = getPoints(session) || [];
        const first = points[0];
        const last = points[points.length - 1];
        const selected = String(session.id) === String(selectedId);

        return (
          <button
            key={session.id}
            type="button"
            className={selected ? "is-active" : ""}
            aria-pressed={selected}
            onClick={() => onSelect(String(session.id))}
          >
            <strong>{getLabel(session)}</strong>

            <span className="live-transports-map__truck-session-links-route">
              <span className="live-transports-map__truck-session-links-side">
                {first && getFlag(first) ? (
                  <span className="live-transports-map__truck-session-links-flag">
                    {getFlag(first)}
                  </span>
                ) : null}

                <span>{first ? getName(first) : "Origem"}</span>
              </span>

              <span className="live-transports-map__truck-session-links-arrow">
                →
              </span>

              <span className="live-transports-map__truck-session-links-side">
                {last && getFlag(last) ? (
                  <span className="live-transports-map__truck-session-links-flag">
                    {getFlag(last)}
                  </span>
                ) : null}

                <span>{last ? getName(last) : "Destino"}</span>
              </span>
            </span>
          </button>
        );
      })}
    </div>
  );
}

export function OperationalSimpleStop({
  number,
  completed = false,
  type,
  name,
  flag,
  postalCode,
  plannedDate,
  plannedTime,
  eta,
  onClick,
  popupClassName = "",
  title = "Focar esta paragem no mapa",
}) {
  const kind = String(type || "").toUpperCase();
  const isPickup = ["PICKUP", "ORIGIN"].includes(kind);
  const isDelivery = ["DELIVERY", "DESTINATION"].includes(kind);
  const hasSchedule = Boolean(plannedDate || plannedTime);

  return (
    <button
      type="button"
      className={[
        "live-transports-map__selection-simple-stop",
        popupClassName,
      ].filter(Boolean).join(" ")}
      onClick={onClick}
      title={title}
    >
      <span
        className={`live-transports-map__selection-simple-index${
          completed ? " is-completed" : ""
        }`}
      >
        {completed ? "✓" : number}
      </span>

      <span className="live-transports-map__selection-simple-pin">
        {isPickup || isDelivery ? (
          <img
            src={isPickup ? pickupPinImage : deliveryPinImage}
            alt={isPickup ? "Carga" : "Descarga"}
            draggable={false}
          />
        ) : (
          <MapPin size={20} aria-hidden="true" />
        )}
      </span>

      <span className="live-transports-map__simple-place">
        <strong
          className="live-transports-map__simple-name"
          title={String(name || "Ponto")}
        >
          {name || "Ponto"}
        </strong>

        {(flag || postalCode) && (
          <small className="live-transports-map__simple-postal">
            {flag}
            {postalCode && <span>{postalCode}</span>}
          </small>
        )}
      </span>

      <span className="live-transports-map__simple-schedule">
        {hasSchedule ? (
          <span className="live-transports-map__simple-planned">
            {plannedDate ? (
              <span className="live-transports-map__simple-date">
                <CalendarDays
                  size={18}
                  strokeWidth={2}
                  aria-hidden="true"
                />
                {plannedDate}
              </span>
            ) : (
              <span className="live-transports-map__simple-unplanned">
                Sem data
              </span>
            )}

            {plannedTime ? (
              <span className="live-transports-map__simple-time">
                <Clock3
                  size={18}
                  strokeWidth={2}
                  aria-hidden="true"
                />
                {plannedTime}
              </span>
            ) : (
              <span className="live-transports-map__simple-unplanned">
                Sem hora
              </span>
            )}
          </span>
        ) : (
          <span className="live-transports-map__simple-unplanned">
            Sem agendamento
          </span>
        )}

        {eta && (
          <span className="live-transports-map__simple-eta">
            ETA · {eta}
          </span>
        )}
      </span>

      <ChevronRight size={15} aria-hidden="true" />
    </button>
  );
}